import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            探索分类
          </h2>
          <p className="text-foreground-500 font-label text-sm max-w-xl mx-auto">
            从时尚穿搭到自我成长，全方位探索熟女魅力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative block rounded-xl overflow-hidden h-64 cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/90 text-background-50 mb-3">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-white mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                  {cat.name}
                </h3>
                <p className="text-xs text-background-200/80 font-label line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}